/* ============================================================
   Discover carousel — layover (dialog) open/close + media control
   ============================================================ */
(function () {
  'use strict';

  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  // Inject the embed iframe lazily on open (so external video only loads/plays
  // when requested) and play any hosted <video>.
  const activate = (dlg) => {
    $$('[data-dv-embed]', dlg).forEach((el) => {
      if (el.querySelector('iframe') || !el.dataset.embedSrc) return;
      const iframe = document.createElement('iframe');
      iframe.src = el.dataset.embedSrc;
      iframe.setAttribute('allow', 'autoplay; encrypted-media; fullscreen; picture-in-picture');
      iframe.setAttribute('allowfullscreen', '');
      iframe.setAttribute('title', 'Video');
      el.appendChild(iframe);
    });
    const video = dlg.querySelector('video');
    if (video) { try { video.play(); } catch (e) { /* ignore */ } }
    document.body.style.overflow = 'hidden';
  };

  // Stop media so it doesn't keep playing in the background once closed.
  const cleanup = (dlg) => {
    const video = dlg.querySelector('video');
    if (video) { try { video.pause(); } catch (e) { /* ignore */ } }
    $$('[data-dv-embed] iframe', dlg).forEach((f) => f.remove());
    document.body.style.overflow = '';
  };

  const open = (dlg) => {
    activate(dlg);
    if (typeof dlg.showModal === 'function') dlg.showModal();
    else dlg.setAttribute('open', '');
  };

  const close = (dlg) => {
    if (typeof dlg.close === 'function' && dlg.open) dlg.close();
    else { dlg.removeAttribute('open'); cleanup(dlg); }
  };

  function boot(root = document) {
    $$('[data-dv-open]', root).forEach((btn) => {
      if (btn.__dvBound) return;
      btn.__dvBound = true;
      btn.addEventListener('click', () => {
        const dlg = document.getElementById(btn.getAttribute('data-dv-open'));
        if (dlg) open(dlg);
      });
    });

    $$('[data-dv-dialog]', root).forEach((dlg) => {
      if (dlg.__dvBound) return;
      dlg.__dvBound = true;
      dlg.querySelector('[data-dv-close]')?.addEventListener('click', () => close(dlg));
      // Click on the backdrop (the dialog element itself) closes it.
      dlg.addEventListener('click', (e) => { if (e.target === dlg) close(dlg); });
      // Native close (ESC or .close()) → stop media + restore scroll.
      dlg.addEventListener('close', () => cleanup(dlg));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => boot());
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (e) => boot(e.target));
})();
